import React, { useEffect, useState, useMemo } from 'react';
import { Search } from 'lucide-react';
import { useUserContext } from '../../contexts/UserContext';
import { getGlobalFunctions } from '../../utils/APIs';
import { useContentfulContext } from '../../contexts/ContentfulContext';
import { AgTableCard, Input } from '../UI';

const GlobalFunctions = () => {
    const [gridApi, setGridApi] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    const getAllTasks = async () => {
        try {
            setLoading(true);
            const res = await getGlobalFunctions(userData?.token, userData?.selectedOrganization?.org_token);
            setRowData(res.data);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllTasks();
    }, []);

    const colDefs = [
        {
            headerName: content.GLOBALFUNCTIONS.table_headers.task_name,
            field: "title",
            filter: true,
            cellRenderer: ({ data }) => {
                return (
                    <div className="relative inline-block text-left">
                        <button
                            className='text-center block cursor-pointer text-primary'
                            // onClick={() => {
                            //     navigate(`/dashboard/experience/edit-task/${data.id}`);
                            // }}
                        >
                            {data.title}
                        </button>
                    </div>
                );
            },
            suppressMovable: true
        },
        {
            headerName: content.GLOBALFUNCTIONS.table_headers.product,
            field: "products",
            cellRenderer: ({ value }) => {
                return value && value.length > 0 ? value.join(", ") : "N/A";
            },
            filter: true,
            sortable: true,
            suppressMovable: true
        },
        {
            headerName: content.GLOBALFUNCTIONS.table_headers.levels,
            field: "levels",
            cellRenderer: ({ value }) => {
                return value && value.length > 0 ? value.join(", ") : "N/A";
            },
            filter: true,
            sortable: true,
            suppressMovable: true
        },
        {
            headerName: content.GLOBALFUNCTIONS.table_headers.available,
            field: "available",
            cellRenderer: ({ value }) => (value ? "Yes" : "No"),
            filter: true,
            sortable: true,
            suppressMovable: true
        }
    ];

    const onFilterTextBoxChanged = (event) => {
        const filterValue = event.target.value.toLowerCase();
        gridApi.setFilterModel({
            title: { type: 'contains', filter: filterValue }
        });
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const autoSizeStrategy = useMemo(() => {
        return {
            type: "fitGridWidth",
            defaultMinWidth: 100,
            columnLimits: [
                { colId: "title", minWidth: 200 },
                { colId: "product", minWidth: 150 },
                { colId: "levels", minWidth: 150 },
                { colId: "available", minWidth: 100 }
            ],
        };
    }, []);

    return (
        <>
            <main id="main" className="flex flex-col w-full space-y-4 my-6 px-4 md:px-8">
                <div className='flex justify-between'>
                    <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">
                        {content.GLOBALFUNCTIONS.title}
                    </h1>
                </div>

                <AgTableCard
                    header={
                        <div className="w-full sm:w-80">
                            <Input
                                placeholder={content.GLOBALFUNCTIONS.search_placeholder}
                                onChange={onFilterTextBoxChanged}
                                prefixIcon={<Search className="w-4 h-4 text-stride-muted" />}
                                clearable
                            />
                        </div>
                    }
                    tableId="global-functions-table"
                    loading={loading}
                    rowData={rowData}
                    columnDefs={colDefs}
                    autoSizeStrategy={autoSizeStrategy}
                    onGridReady={onGridReady}
                />
            </main>
        </>
    );
};

export default GlobalFunctions;
